import moment from "moment";
import React, { Component } from "react";
import { adToBsDate } from "../../../../utils/Utils";

class GeneralAssessmentDetailTableRow extends Component {
  state = {};
  render() {
    let general = this.props.generalDetail;
    return (
      <tr key={this.props.generalIdx}>
        <td>
          {general.assessmentFromDate
            ? `${adToBsDate(general.assessmentFromDate)}`
            : "No date"}
        </td>
        <td>
          {general.assessmentToDate
            ?`${adToBsDate(general.assessmentToDate)}`
            : "No date"}
        </td>
        <td>
          {general.recordingDate
            ?`${adToBsDate(general.recordingDate)}`
            : "No date"}
        </td>
        <td>
          {general.recordingDeadlineDate
            ?`${adToBsDate(general.recordingDeadlineDate)}`
            : "No date"}
        </td>
      </tr>
    );
  }
}

export default GeneralAssessmentDetailTableRow;
